import React from 'react'
import {instance as userService} from '../../services/UserService'
import {App, message} from 'antd'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'

export function LogOutLink() {
  const intl = useIntl()
  const [messageApi, contextHolder] = message.useMessage()
  const navigate = useNavigate()
  const app = App.useApp()

  return (
    <a
      href="#"
      onClick={async (e) => {
        e.preventDefault()
        const result = await userService.signOut()
        if (!result.success) {
          app.message.open({
            type: 'error',
            content: result.error.message,
          })
        } else {
          navigate('/')
        }
      }}
    >
      {intl.formatMessage({id: 'logOut'})}
    </a>
  )
}
